import {HOST_API} from 'src/config-global';

const RATING_SAVE_API_URI = '/api/rating/save';

export async function saveRating(ratingValue, recipeId) {
  const response = await fetch(`${HOST_API}${RATING_SAVE_API_URI}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
    },
    body: JSON.stringify({ratingValue, recipeId})
  });

  if (!response.ok) {
    let message = `${response.status}:${response.statusText}`;
    if (response.status < 500) {
      const responseData = await response.json();
      message = responseData.error;
    }

    throw new Error(message);
  }

  return response.json();
}

